<div
  #conditions
  (pointerover)="point($event.target)"
  (focusin)="point($event.target)"
  (mouseleave)="leave(conditions)"
  (focusout)="focusLeaves($event, conditions)">
  <app-path-filter-group
    placement="root"
    [group]="draft()"
    [context]="context()"
    (groupChange)="draft.set($event)" />
</div>
@if (!pinned && showPhrase()) {
  <ng-container [ngTemplateOutlet]="phrase" />
}

<ng-template #phrase>
  <app-path-filter-phrase [class.mt-2]="!pinned" [segments]="segments()" />
</ng-template>
